export var PlacementGrouping;
(function (PlacementGrouping) {
    PlacementGrouping[PlacementGrouping["None"] = 0] = "None";
    PlacementGrouping[PlacementGrouping["Client"] = 1] = "Client";
    PlacementGrouping[PlacementGrouping["Place"] = 2] = "Place";
})(PlacementGrouping || (PlacementGrouping = {}));
